import { render } from "./CrudEmpresa.vue?vue&type=template&id=0905404f"
import script from "./CrudEmpresa.vue?vue&type=script&lang=js"
export * from "./CrudEmpresa.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__